export default __webpack_public_path__ + "static/volt-farmer-20fef2220b8fe0e3bb5a8c53da6d3bc7.png";